export default __webpack_public_path__ + "static/media/news5.e20fe776.webp";